import { SoundCategory } from '../../services/SoundLibrary/soundCategory';
import ListGroup from 'react-bootstrap/ListGroup';
import React, { CSSProperties } from 'react';
import { SupportedStatus } from '../../services/SoundLibrary/supportedStatus';
import { Variant } from 'react-bootstrap/types';
import PlaySoundCategoryButton from './PlaySoundCategoryButton';
import './SoundCategoryListItem.scss';
import ClickableCode from './ClickableCode';
import { useDraggable } from '@dnd-kit/core';

export interface SoundCategoryListItemProps {
  category: SoundCategory;
  style: CSSProperties
  draggingDisabled?: boolean
}

export default function SoundCategoryListItem({ category, style, draggingDisabled = false }: SoundCategoryListItemProps) {
  return <ListGroup.Item variant={variantMap[category.supported]} className="" style={style}>
    <div className="d-flex align-items-center">
      <div className="flex-grow-1">
        <h4 className="mt-1">{category.displayName}</h4>
        <p className="my-1">ID: <ClickableCode>{category.name}</ClickableCode></p>
      </div>
      {category.supported !== SupportedStatus.NONE &&
      <div className="sound-list-actions flex-shrink-0">
        <PlaySoundCategoryButton category={category}/>
        <SoundListDragHandle category={category} disabled={draggingDisabled}/>
      </div>}
    </div>
  </ListGroup.Item>
}

function SoundListDragHandle({ category, disabled }: { category: SoundCategory; disabled: boolean }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `sound-source:${category.name}`,
    data: {
      kind: 'sound-source',
      soundEvent: category.name,
      displayName: category.displayName,
    },
    disabled,
  });

  return <button
    type="button"
    ref={setNodeRef}
    className={`sound-list-drag-handle ${isDragging ? 'is-dragging' : ''}`}
    disabled={disabled}
    title="Drag to sequencer"
    {...attributes}
    {...listeners}
  >
    <i className="bi-grip-vertical"/>
  </button>;
}

export const variantMap: Record<SupportedStatus, Variant | undefined> = {
  [SupportedStatus.FULL]: undefined,
  [SupportedStatus.PARTIAL]: 'warning',
  [SupportedStatus.NONE]: 'danger',
};
